import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const NotAssignedIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <rect
        x="2.66675"
        y="7.11108"
        width="1.77778"
        height="1.77778"
        rx="0.888889"
      />
      <rect
        x="7.11108"
        y="7.11108"
        width="1.77778"
        height="1.77778"
        rx="0.888889"
      />
      <rect
        x="11.5557"
        y="7.11108"
        width="1.77778"
        height="1.77778"
        rx="0.888889"
      />
    </IconWrapper>
  );
};

export default NotAssignedIcon;
